import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { resolveColorForName } from '../../utils/nameColors';

const formatPercent = (value) => `${Number(value || 0).toFixed(1)}%`;

const ResumePieChart = ({ title, data, nameKey, colorMap, emptyMessage }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const chartData = data || [];

  if (!chartData.length) {
    return (
      <Paper sx={{ p: 2, height: '100%', color: 'text.primary' }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2, color: 'text.primary' }}>
          {title}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 280 }}>
          <Typography color="text.secondary">{emptyMessage}</Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 2, height: '100%', color: 'text.primary' }}>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2, color: 'text.primary' }}>
        {title}
      </Typography>
      <Box sx={{ width: '100%', height: 320 }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={chartData}
              dataKey="count"
              nameKey={nameKey}
              cx="50%"
              cy="50%"
              innerRadius={55}
              outerRadius={95}
              paddingAngle={1}
            >
              {chartData.map((entry) => (
                <Cell
                  key={entry[nameKey]}
                  fill={resolveColorForName(entry[nameKey], colorMap, isDarkMode)}
                  stroke="none"
                />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, _name, props) => [
                `${value} (${formatPercent(props.payload.percent)})`,
                props.payload[nameKey],
              ]}
              contentStyle={{
                backgroundColor: theme.palette.background.paper,
                borderColor: theme.palette.divider,
                color: theme.palette.text.primary,
              }}
              labelStyle={{ color: theme.palette.text.primary }}
              itemStyle={{ color: theme.palette.text.primary }}
            />
          </PieChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

export default ResumePieChart;
